module.exports = __webpack_public_path__ + "img/lock.be990f44.png";